import { Signal } from "@angular/core";
import { ViewDataCache } from "./view-data-cache";
import { Refresher } from "./refresher";
import { BaseRepository, QueryParameters } from "../../04_repository/base-repository";
import { paginationData, PaginationData } from "../../02_ui/paginated-list-simple/paginated-list-simple.component";

export interface ViewService<T> {

  cache?: ViewDataCache;
  refresher?: Refresher;
  repository?: BaseRepository<T extends { id: string } ? T : never>;

  activateViewIdentity(id: string): Signal<T|PageViewModel<T>>;
  deactivateViewIdentity(id: string): void;

}

export type PageViewModel<T> = {
  data: T[];
  queryParameters: QueryParameters;
  pagination: PaginationData<T>;
}


export const DEFAULT_QUERY_PARAMETERS: QueryParameters = {
  searchParameters: [],
  sortKey: 'createdAt',
  sortDirection: 'desc'
};

export function emptyPageViewModel<T>(): PageViewModel<T> {
  return {
    data: [],
    queryParameters: { ...DEFAULT_QUERY_PARAMETERS },
    pagination: paginationData<T>()
  };
}
